<template>
  <div id="mainClosedDataWrapper">
    <div id="chooseEmployee">
      <a-row type="flex">
        <a-col>
          <h2>{{ $t("employee") }}</h2>
        </a-col>
        <a-col style="flex: 1; margin-left: 15px">
          <a-select
            v-if="isAdmin || userAccess.some((x) => ['HR', 'CEPO'].includes(x))"
            style="width: 100%; text-align: center"
            showSearch
            @search="searchUser"
            :filter-option="false"
            :default-value="
              userInfo[currentUserIdForEdit].LAST_NAME +
              ' ' +
              userInfo[currentUserIdForEdit].NAME
            "
            @change="changeCurrentUserIdForEdit"
          >
            <a-select-option
              v-for="employee in filterUserList"
              :key="employee.ID"
              :value="employee.ID"
            >
              <a-avatar
                v-if="employee.PERSONAL_PHOTO"
                style="width: 24px; height: 24px; margin-bottom: 3px"
                :src="employee.PERSONAL_PHOTO"
              />
              <a-avatar
                v-else
                style="
                  width: 25px;
                  height: 25px;
                  color: #f56a00;
                  background-color: #fde3cf;
                  margin-bottom: 3px;
                  line-height: 24px;
                  font-weight: 500;
                "
                >{{ employee.NAME ? employee.NAME[0] : "?" }}</a-avatar
              >
              {{ `${employee.LAST_NAME} ${employee.NAME}` }}
            </a-select-option>
          </a-select>
          <a-col v-else style="margin: 0 0 0 15px">
            <h2>
              <a-avatar
                style="width: 25px; height: 25px; margin-right: 5px"
                :src="currentUserObj.PERSONAL_PHOTO"
              />
              {{ currentUserObj.LAST_NAME + " " + currentUserObj.NAME }}
            </h2>
          </a-col>
        </a-col>
      </a-row>
    </div>
    <a-row gutter="16">
      <a-col :span="12">
        <div id="employmentData">
          <a-descriptions
            bordered
            :title="$t('Dane o zatrudnieniu')"
            size="small"
            :column="1"
          >
            <a-descriptions-item :label="$t('StanZatrudnienia')">
              <span v-if="!editableAllFields">
                {{
                  closedUserData.StanZatrudnienia
                    ? $t(closedUserData.StanZatrudnienia)
                    : ""
                }}
              </span>
              <a-select
                v-if="editableAllFields"
                allowClear
                style="width: 100%"
                v-model="StanZatrudnienia"
              >
                <a-select-option value="Zatrudniony">
                  {{ $t("Zatrudniony") }}
                </a-select-option>
                <a-select-option value="Zawieszony">
                  {{ $t("Zawieszony") }}
                </a-select-option>
                <a-select-option value="Zwolniony">
                  {{ $t("Zwolniony") }}
                </a-select-option>
                <a-select-option value="Emerytura">
                  {{ $t("Emerytura") }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item
              :label="$t('FormaRozwiazania')"
              v-if="StanZatrudnienia == 'Zwolniony'"
            >
              <span v-if="!editableAllFields">
                {{
                  closedUserData.FormaRozwiazania
                    ? $t(closedUserData.FormaRozwiazania)
                    : ""
                }}
              </span>
              <a-select
                v-if="editableAllFields"
                style="width: 100%; text-align: center"
                :showSearch="true"
                allowClear
                v-model="FormaRozwiazania"
              >
                <a-select-option value="za porozumieniem stron">
                  {{ $t("za porozumieniem stron") }}
                </a-select-option>
                <a-select-option value="ze strony pracodawcy">
                  {{ $t("ze strony pracodawcy") }}
                </a-select-option>
                <a-select-option value="ze strony pracownika">
                  {{ $t("ze strony pracownika") }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('TypZatrudnienia')">
              <a-select
                v-if="editableAllFields"
                style="width: 100%; text-align: center"
                :showSearch="true"
                allowClear
                v-model="TypZatrudnienia"
              >
                <a-select-option value="Dzialalnosc gospodarcza">
                  {{ $t("za porozumieniem stron") }}
                </a-select-option>
                <a-select-option value="Kontrakt menadzerski">
                  {{ $t("Kontrakt menadzerski") }}
                </a-select-option>
                <a-select-option value="Praktyki">
                  {{ $t("Praktyki") }}
                </a-select-option>
                <a-select-option value="Staz">
                  {{ $t("Staz") }}
                </a-select-option>
                <a-select-option value="Umowa o prace">
                  {{ $t("Umowa o prace") }}
                </a-select-option>
                <a-select-option value="Umowa zlecenie">
                  {{ $t("Umowa zlecenie") }}
                </a-select-option>
                <a-select-option value="Umowa o dzielo">
                  {{ $t("Umowa o dzielo") }}
                </a-select-option>
              </a-select>
              <span v-if="!editableAllFields">
                {{
                  closedUserData.TypZatrudnienia
                    ? $t(closedUserData.TypZatrudnienia)
                    : ""
                }}
              </span>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('NazwaFirmy')">
              <span v-if="!editableAllFields">
                {{
                  closedUserData.NazwaFirmy ? closedUserData.company.TITLE : ""
                }}
              </span>
              <a-input
                v-if="editableAllFields"
                style="width: 100%; text-align: center"
                allowClear
                v-model="companyTitle"
                @click="handleChangeCompany()"
              />
              <!--<a-select
                  v-if="editableAllFields"
                  style="width: 100%; text-align: center"
                  showSearch
                  optionFilterProp="children"
                  v-model="NazwaFirmy"
                  allowClear
                >
                  <a-select-option
                    v-for="comp in allcompanies"
                    style="width: 80%"
                    :key="comp.ID"
                  >
                    {{ comp.TITLE }}
                  </a-select-option>
                </a-select>-->
            </a-descriptions-item>
            <a-descriptions-item :label="$t('DataZatrudnienia')">
              <span v-if="!editableAllFields">
                {{ closedUserData.DataZatrudnienia }}
              </span>
              <a-date-picker
                v-if="editableAllFields"
                v-model="DataZatrudnienia"
                :format="dateFormat"
                style="width: 100%; text-align: center"
              />
            </a-descriptions-item>
            <a-descriptions-item :label="$t('DataZakonczeniaRozwiazania')">
              <span v-if="!editableAllFields">
                {{ closedUserData.DataZakonczeniaRozwiazania }}
              </span>
              <a-date-picker
                v-if="editableAllFields"
                v-model="DataZakonczeniaRozwiazania"
                style="width: 100%; text-align: center"
              />
            </a-descriptions-item>
            <a-descriptions-item
              :label="$t('dataZvolnienia')"
              v-if="StanZatrudnienia == 'Zwolniony'"
            >
              <span v-if="!editableAllFields">
                {{ closedUserData.dataZvolnienia }}
              </span>
              <a-date-picker
                v-if="editableAllFields"
                v-model="dataZvolnienia"
                style="width: 100%; text-align: center"
              />
            </a-descriptions-item>
            <a-descriptions-item :label="$t('Wynagrodzenie')">
              <span v-if="!editableAllFields">
                {{ closedUserData.Wynagrodzenie }}
              </span>
              <a-input v-if="editableAllFields" v-model="Wynagrodzenie" />
            </a-descriptions-item>
            <a-descriptions-item :label="$t('Prowizja')">
              <span v-if="!editableAllFields">
                {{ closedUserData.Prowizja }}
              </span>
              <a-input v-if="editableAllFields" v-model="Prowizja" />
            </a-descriptions-item>
            <a-descriptions-item :label="$t('Premia')">
              <span v-if="!editableAllFields">
                {{ closedUserData.Premia }}
              </span>
              <a-input v-if="editableAllFields" v-model="Premia" />
            </a-descriptions-item>
            <a-descriptions-item :label="$t('additionalEmployeeInformation')">
              <div v-if="!editableAllFields">
                <span
                  v-for="(
                    item, index
                  ) in closedUserData.additionalEmployeeInformation"
                  :key="index"
                >
                  <a-tag v-if="item.status" color="green">
                    {{ item.name }}
                  </a-tag>
                </span>
              </div>
              <div v-if="editableAllFields">
                <a-input
                  allow-clear
                  v-model="item.name"
                  v-for="(item, index) in additionalEmployeeInformation"
                  :key="index"
                >
                  <a-checkbox slot="prefix" v-model="item.status" />
                  <a-tooltip slot="suffix" title="Delete item information">
                    <a-icon
                      type="delete"
                      @click="deleteAdditionalInfoItem(index)"
                      style="color: red"
                    />
                  </a-tooltip>
                </a-input>
                <a style="float: right" @click="addNewAdditionalInfofmation">
                  <a-icon type="edit" />
                </a>
              </div>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('BadaniaLekarskie')">
              <span
                v-if="
                  !editableAllFields &&
                  Array.isArray(closedUserData.BadaniaLekarskie) &&
                  closedUserData.BadaniaLekarskie.length
                "
              >
                {{
                  closedUserData.BadaniaLekarskie
                    ? `${closedUserData.BadaniaLekarskie[0]} - ${closedUserData.BadaniaLekarskie[1]}`
                    : ""
                }}
              </span>
              <div
                v-if="
                  editableAllFields &&
                  Array.isArray(closedUserData.BadaniaLekarskie) &&
                  closedUserData.BadaniaLekarskie.length
                "
              >
                <a-date-picker
                  :placeholder="$t('from')"
                  :format="dateFormat"
                  style="width: 100%; text-align: center"
                  v-model="BadaniaLekarskie[0]"
                  @change="calendarChangeBadaniaSE($event, 'start')"
                />
                <a-date-picker
                  :placeholder="$t('to')"
                  :format="dateFormat"
                  style="width: 100%; text-align: center"
                  v-model="BadaniaLekarskie[1]"
                  @change="calendarChangeBadaniaSE($event, 'end')"
                />
              </div>
              <div v-else>
                <a-date-picker
                  v-if="editableAllFields"
                  :placeholder="$t('from')"
                  :format="dateFormat"
                  style="width: 100%; text-align: center"
                  v-model="BadaniaLekarskie[0]"
                  @change="calendarChangeBadaniaSE($event, 'start')"
                />
                <a-date-picker
                  v-if="editableAllFields"
                  :placeholder="$t('to')"
                  :format="dateFormat"
                  style="width: 100%; text-align: center"
                  v-model="BadaniaLekarskie[1]"
                  @change="calendarChangeBadaniaSE($event, 'end')"
                />
              </div>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('SzkolenieBHP')">
              <span
                v-if="
                  !editableAllFields &&
                  Array.isArray(closedUserData.SzkolenieBHP) &&
                  closedUserData.SzkolenieBHP.length
                "
              >
                {{
                  closedUserData.SzkolenieBHP
                    ? `${closedUserData.SzkolenieBHP[0]} - ${closedUserData.SzkolenieBHP[1]}`
                    : ""
                }}
              </span>
              <div
                v-if="
                  editableAllFields &&
                  Array.isArray(closedUserData.SzkolenieBHP) &&
                  closedUserData.SzkolenieBHP.length
                "
              >
                <a-date-picker
                  :placeholder="$t('from')"
                  :format="dateFormat"
                  style="width: 100%; text-align: center"
                  v-model="SzkolenieBHP[0]"
                  @change="calendarChangeBHP($event, 'start')"
                />
                <a-date-picker
                  :placeholder="$t('to')"
                  :format="dateFormat"
                  style="width: 100%; text-align: center"
                  v-model="SzkolenieBHP[1]"
                  @change="calendarChangeBHP($event, 'end')"
                />
              </div>
              <div v-else>
                <a-date-picker
                  v-if="editableAllFields"
                  :placeholder="$t('from')"
                  :format="dateFormat"
                  style="width: 100%; text-align: center"
                  v-model="SzkolenieBHP[0]"
                  @change="calendarChangeBHP($event, 'start')"
                />
                <a-date-picker
                  v-if="editableAllFields"
                  :placeholder="$t('to')"
                  :format="dateFormat"
                  style="width: 100%; text-align: center"
                  v-model="SzkolenieBHP[1]"
                  @change="calendarChangeBHP($event, 'end')"
                />
              </div>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('WymiarUrlopu')">
              <div v-if="!editableAllFields">
                <div
                  v-if="
                    closedUserData.WymiarUrlopu &&
                    closedUserData.WymiarUrlopu.length
                  "
                >
                  <a-row type="flex">
                    <a-col
                      style="
                        flex: 1;
                        text-align: center;
                        border-right: 1px solid #d3d3d3;
                        border-bottom: 1px solid #d3d3d3;
                      "
                    >
                      {{ $t("date") }}
                    </a-col>
                    <a-col
                      style="
                        flex: 1;
                        text-align: center;
                        border-bottom: 1px solid #d3d3d3;
                      "
                    >
                      {{ $t("amount") }}
                    </a-col>
                  </a-row>
                </div>
                <div
                  v-for="(item, index) in closedUserData.WymiarUrlopu"
                  :key="index"
                >
                  <a-row type="flex">
                    <a-col
                      style="
                        flex: 1;
                        text-align: center;
                        border-right: 1px solid #d3d3d3;
                      "
                    >
                      {{ item.date }}
                    </a-col>
                    <a-col style="flex: 1; text-align: center">
                      {{ item.name }}
                    </a-col>
                  </a-row>
                </div>
              </div>
              <div v-if="editableAllFields" style="text-align: center">
                <div v-for="(item, index) in holidaysMass" :key="index">
                  <a-row type="flex">
                    <a-col style="flex: 1">
                      <a-select
                        style="width: 100%"
                        :showSearch="true"
                        :default-value="item.date || moment().format('YYYY')"
                        @change="handleChangeYearUrlopu($event, index)"
                      >
                        <a-select-option
                          v-for="item in arrYears"
                          :key="item"
                          :value="item"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </a-col>
                    <a-col style="flex: 1">
                      <a-input-number
                        style="width: 100%"
                        allow-clear
                        :min="1"
                        v-model="item.name"
                      />
                    </a-col>
                    <a-col>
                      <div>
                        <a-tooltip title="Delete item information">
                          <a-icon
                            type="delete"
                            @click="deleteholidaysMass(index)"
                            style="color: red"
                          />
                        </a-tooltip>
                      </div>
                    </a-col>
                  </a-row>
                </div>
                <a style="float: right" @click="addholidaysMass()">
                  <a-icon type="edit" />
                </a>
              </div>
            </a-descriptions-item>
            <!-- <a-list-item>
              <div class="itemsInfoTitle">{{$t('Ekwiwalent')}}</div>
              <div class="itemsInfo">
                <span v-if="!editableAllFields">{{closedUserData.Ekwiwalent}}</span>
                <a-input v-if="editableAllFields" v-model="Ekwiwalent" />
              </div>
            </a-list-item>-->
            <a-descriptions-item :label="$t('Student')">
              <span v-if="!editableAllFields">
                {{ closedUserData.Student ? $t(closedUserData.Student) : "" }}
              </span>
              <a-select
                v-if="editableAllFields"
                style="width: 100%; text-align: center"
                :showSearch="true"
                v-model="Student"
              >
                <a-select-option v-for="val in yesOrNo" :key="val">
                  {{ $t(val) }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('Samozatrudnienie')">
              <span v-if="!editableAllFields">
                {{
                  closedUserData.Samozatrudnienie
                    ? $t(closedUserData.Samozatrudnienie)
                    : ""
                }}
              </span>
              <a-select
                v-if="editableAllFields"
                style="width: 100%; text-align: center"
                :showSearch="true"
                v-model="Samozatrudnienie"
              >
                <a-select-option v-for="yesNo in yesOrNo" :key="yesNo">
                  {{ $t(yesNo) }}
                </a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('LiczbaDni')">
              <span>{{ +DniWRoku - +UzywaneDni }}</span>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </a-col>
      <a-col :span="12">
        <div id="workerData">
          <a-descriptions
            bordered
            :title="$t('Rozwoj Pracownika')"
            size="small"
            :column="1"
          >
            <a-descriptions-item :label="$t('employeeGoalsInformation')">
              <div v-if="!editableAllFields2">
                <a-row
                  type="flex"
                  v-for="(
                    item, index
                  ) in closedUserData.employeeGoalsInformation"
                  :key="index"
                >
                  <a-col style="flex: 1">{{ item.name }}</a-col>
                  <a-col style="flex: 1">
                    {{ item.date[0] | dateFilter }} -
                    {{ item.date[1] | dateFilter }}
                  </a-col>
                </a-row>
              </div>

              <div v-if="editableAllFields2" style="text-align: center">
                <div
                  v-for="(item, index) in employeeGoalsInformation"
                  :key="index"
                >
                  <a-row type="flex">
                    <a-col style="flex: 1">
                      <a-input allow-clear v-model="item.name" />
                    </a-col>
                    <a-col style="flex: 1">
                      <a-range-picker
                        v-if="item.date.length != 0"
                        :default-value="[
                          moment(item.date[0], dateFormat),
                          moment(item.date[1], dateFormat),
                        ]"
                        :format="dateFormat"
                        style="width: 100%"
                        @calendarChange="calendarChangeGoals($event, index)"
                      />
                      <a-range-picker
                        v-else
                        style="width: 100%"
                        :default-value="[null, null]"
                        :format="dateFormat"
                        @calendarChange="calendarChangeGoals($event, index)"
                      />
                    </a-col>
                    <a-col style="margin: auto 5px">
                      <div>
                        <a-tooltip title="Delete item information">
                          <a-icon
                            type="delete"
                            @click="deleteAdditionalInfoItemGoals(index)"
                            style="color: red"
                          />
                        </a-tooltip>
                      </div>
                    </a-col>
                  </a-row>
                </div>
                <a
                  style="float: right"
                  @click="addNewEmployeeDevelopmentInfoGoals()"
                >
                  <a-icon type="edit" />
                </a>
              </div>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('competenceEmployeeInformation')">
              <div v-if="!editableAllFields2">
                <a-row
                  type="flex"
                  v-for="(
                    item, index
                  ) in closedUserData.competenceEmployeeInformation"
                  :key="index"
                >
                  <a-col style="flex: 1">{{ item.name }}</a-col>
                  <a-col style="flex: 1">
                    {{ item.date[0] | dateFilter }} -
                    {{ item.date[1] | dateFilter }}
                  </a-col>
                </a-row>
              </div>

              <div v-if="editableAllFields2" style="text-align: center">
                <div
                  v-for="(item, index) in competenceEmployeeInformation"
                  :key="index"
                >
                  <a-row type="flex">
                    <a-col style="flex: 1">
                      <a-input allow-clear v-model="item.name" />
                    </a-col>
                    <a-col style="flex: 1">
                      <a-range-picker
                        v-if="item.date.length != 0"
                        :default-value="[
                          moment(item.date[0], dateFormat),
                          moment(item.date[1], dateFormat),
                        ]"
                        :format="dateFormat"
                        style="width: 100%"
                        @calendarChange="
                          calendarChangeСompetence($event, index)
                        "
                      />
                      <a-range-picker
                        v-else
                        style="width: 100%"
                        :default-value="[null, null]"
                        :format="dateFormat"
                        @calendarChange="
                          calendarChangeСompetence($event, index)
                        "
                      />
                    </a-col>
                    <a-col style="margin: auto 5px">
                      <div>
                        <a-tooltip title="Delete item information">
                          <a-icon
                            type="delete"
                            @click="deleteAdditionalInfoItemCompetence(index)"
                            style="color: red"
                          />
                        </a-tooltip>
                      </div>
                    </a-col>
                  </a-row>
                </div>
                <a
                  style="float: right"
                  @click="addNewEmployeeDevelopmentInfoСompetence()"
                >
                  <a-icon type="edit" />
                </a>
              </div>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('trainingEmployeeInformation')">
              <div v-if="!editableAllFields2 && closedUserData !== null">
                <a-row
                  type="flex"
                  v-for="(
                    item, index
                  ) in closedUserData.trainingEmployeeInformation"
                  :key="index"
                >
                  <a-col style="flex: 1">{{ item.name }}</a-col>
                  <a-col style="flex: 1">
                    {{ item.date[0] | dateFilter }} -
                    {{ item.date[1] | dateFilter }}
                  </a-col>
                </a-row>
              </div>

              <div v-if="editableAllFields2" style="text-align: center">
                <div
                  v-for="(item, index) in trainingEmployeeInformation"
                  :key="index"
                >
                  <a-row type="flex">
                    <a-col style="flex: 1">
                      <a-input allow-clear v-model="item.name" />
                    </a-col>
                    <a-col style="flex: 1">
                      <a-range-picker
                        v-if="item.date.length != 0"
                        :default-value="[
                          moment(item.date[0], dateFormat),
                          moment(item.date[1], dateFormat),
                        ]"
                        :format="dateFormat"
                        style="width: 100%"
                        @calendarChange="calendarChangeTraining($event, index)"
                      />
                      <a-range-picker
                        v-else
                        style="width: 100%"
                        :default-value="[null, null]"
                        :format="dateFormat"
                        @calendarChange="calendarChangeTraining($event, index)"
                      />
                    </a-col>
                    <a-col style="margin: auto 5px">
                      <div>
                        <a-tooltip title="Delete item information">
                          <a-icon
                            type="delete"
                            @click="deleteAdditionalInfoItemTraining(index)"
                            style="color: red"
                          />
                        </a-tooltip>
                      </div>
                    </a-col>
                  </a-row>
                </div>
                <a
                  style="float: right"
                  @click="addNewEmployeeDevelopmentInfoTraining()"
                >
                  <a-icon type="edit" />
                </a>
              </div>
            </a-descriptions-item>
            <a-descriptions-item
              :label="$t('evaluationFormEmployeeInformation')"
            >
              <div v-if="!editableAllFields2">
                <a-row
                  type="flex"
                  v-for="(
                    item, index
                  ) in closedUserData.evaluationFormEmployeeInformation"
                  :key="index"
                >
                  <a-col style="flex: 1">{{ item.name }}</a-col>
                  <a-col style="flex: 1">
                    {{ item.date[0] | dateFilter }} -
                    {{ item.date[1] | dateFilter }}
                  </a-col>
                </a-row>
              </div>
              <div v-if="editableAllFields2" style="text-align: center">
                <div
                  v-for="(item, index) in evaluationFormEmployeeInformation"
                  :key="index"
                >
                  <a-row type="flex">
                    <a-col style="flex: 1">
                      <a-input allow-clear v-model="item.name" />
                    </a-col>
                    <a-col style="flex: 1">
                      <a-range-picker
                        v-if="item.date.length != 0"
                        :default-value="[
                          moment(item.date[0], dateFormat),
                          moment(item.date[1], dateFormat),
                        ]"
                        :format="dateFormat"
                        style="width: 100%"
                        @calendarChange="
                          calendarChangeEvaluation($event, index)
                        "
                      />
                      <a-range-picker
                        v-else
                        style="width: 100%"
                        :default-value="[null, null]"
                        :format="dateFormat"
                        @calendarChange="
                          calendarChangeEvaluation($event, index)
                        "
                      />
                    </a-col>
                    <a-col style="margin: auto 5px">
                      <div>
                        <a-tooltip title="Delete item information">
                          <a-icon
                            type="delete"
                            @click="deleteAdditionalInfoItemEvaluation(index)"
                            style="color: red"
                          />
                        </a-tooltip>
                      </div>
                    </a-col>
                  </a-row>
                </div>
                <a
                  style="float: right"
                  @click="addNewEmployeeDevelopmentInfoEvaluation()"
                >
                  <a-icon type="edit" />
                </a>
              </div>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('PlanRozwojuPracownika')">
              <div v-if="editableAllFields2">
                <a-textarea
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                  v-model="PlanRozwojuPracownika"
                />
              </div>
              <div v-else>
                {{ closedUserData.PlanRozwojuPracownika || "" }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('Attachment')">
              <div
                v-if="!editableAllFields2 && closedUserData !== null"
                style="text-align: center"
              >
                <div v-if="closedUserData.files">
                  <a-tag
                    v-for="iteration in closedUserData.files"
                    :key="iteration"
                    color="blue"
                  >
                    <a target="_blank" :href="iteration.DETAIL_URL">
                      {{ iteration.NAME }}
                    </a>
                  </a-tag>
                </div>
              </div>
              <div
                v-if="editableAllFields2 && closedUserData !== null"
                style="text-align: center"
              >
                <a-upload
                  :default-file-list="closedUserData.files ? Zatacznik : []"
                  :beforeUpload="beforeUpload"
                  :remove="handleRemove"
                  style="margin-right: 15px"
                  :multiple="true"
                >
                  <a-button type="primary" shape="round" icon="upload"
                    >Add new</a-button
                  >
                </a-upload>
              </div>
            </a-descriptions-item>
          </a-descriptions>
        </div>

        <a-row
          v-if="editableAllFields || editableAllFields2"
          type="flex"
          justify="space-around"
          class="btn-closed"
        >
          <a-button type="primary" @click="saveAllFields">
            {{ $t("Zapisz") }}
          </a-button>
          <a-button type="danger" @click="cancelAllFields">
            {{ $t("Anuluj") }}
          </a-button>
        </a-row>
        <div v-else>
          <a-button
            v-if="
              isAdmin ||
              userAccess.some((x) => ['HR', 'Office', 'Chief'].includes(x))
            "
            type="primary"
            @click="editAllFields"
            class="btn-closed"
          >
            {{ $t("Edytuj") }}
          </a-button>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from "moment";
import { updateAuth, generateFormDataWithImage } from "../requestFunc";
export default {
  props: [
    "currentUserIdForEdit",
    "userInfo",
    "companies",
    "allcompanies",
    "closedUserData",
    "adtlEmplInfDataSource",
    "isAdmin",
    "userAccess",
    "UzywaneDni",
    "DniWRoku",
    "DniNieobecnosci",
    "daysLeft",
    "currentBxUserDepartments",
    "infoo_currentUsersInDepartments",
    "currentUserObj",
  ],
  data() {
    return {
      fileList: [
        {
          uid: "-1",
          name: "xxx.png",
          status: "done",
          url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
          thumbUrl:
            "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        },
        {
          uid: "-2",
          name: "yyy.png",
          status: "done",
          url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
          thumbUrl:
            "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        },
      ],
      dateFormat: "YYYY-MM-DD",
      editableAllFields: false,
      editableAllFields2: false,
      headers: {
        authorization: "authorization-text",
      },
      StanZatrudnienia: "",
      FormaRozwiazania: "",
      TypZatrudnienia: "",
      NazwaFirmy: "",
      DataZatrudnienia: "",
      DataZakonczeniaRozwiazania: "",
      dataZvolnienia: "",
      Wynagrodzenie: "",
      companyTitle: "",
      comapny: "",
      Prowizja: "",
      Premia: "",
      BadaniaLekarskie: [null, null],
      SzkolenieBHP: [null, null],
      WymiarUrlopu: "",
      Ekwiwalent: "",
      Student: "",
      Samozatrudnienie: "",
      LiczbaDostepnychDni: "",
      PlanRozwojuPracownika: "",
      Zatacznik: [],
      employmentStatuses: [
        "Zatrudniony",
        "Zawieszony",
        "Zwolniony",
        "Emerytura",
      ],
      decisidionForms: [
        "za porozumieniem stron",
        "ze strony pracodawcy",
        "ze strony pracownika",
      ],
      employmentеTypes: [
        "Działalność gospodarcza",
        "Kontrakt menadżerski",
        "Praktyki",
        "Staż",
        "Umowa o pracę",
        "Umowa zlecenie",
        "Umowa o dzieło",
      ],
      additionalEmployeeInformation: [],
      holidaysMass: [],
      employeeGoalsInformation: [],
      competenceEmployeeInformation: [],
      trainingEmployeeInformation: [],
      evaluationFormEmployeeInformation: [],
      yesOrNo: ["Tak", "Nie"],
      additionalData: [],
      holidayPeriods: [],
      employeeGoalsPeriods: [],
      competenceEmployeePeriods: [],
      evaluationFormEmployeePeriods: [],
      trainingEmployeePeriods: [],
      arrYears: Array(100)
        .fill(0)
        .map((e, i) => 2009 + i + 1),
      arrYearsExample: Array(100)
        .fill(0)
        .map((e, i) => 2009 + i + 1),
      idFileRemove: [],
      searchUserInput: "",
    };
  },
  filters: {
    dateFilter(value) {
      return moment(value).format("YYYY-MM-DD");
    },
  },
  computed: {
    filterUserList() {
      return this.userInfo
        .map((el, index) => ({ ...el, index }))
        .filter((el) => {
          return (
            (el.LAST_NAME + " " + el.NAME)
              .toLowerCase()
              .indexOf(this.searchUserInput.toLowerCase()) > -1
          );
        });
    },
  },
  methods: {
    moment,
    handleChangeCompany() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.NazwaFirmy = info.company[0].id.split("_")[1];
          this.companyTitle = info.company[0].title;
        }
      );
    },
    handleRemove(file) {
      const index = this.Zatacznik.indexOf(file);
      const newFileList = this.Zatacznik.slice();
      newFileList.splice(index, 1);
      this.Zatacznik = newFileList;

      this.idFileRemove.push(file.uid);
    },
    formFileList() {
      for (var key in this.closedUserData.files) {
        this.Zatacznik.push({
          uid: this.closedUserData.files[key].ID,
          name: this.closedUserData.files[key].NAME,
          status: "done",
          url: this.closedUserData.files[key].DETAIL_URL,
          thumbUrl: this.closedUserData.files[key].DETAIL_URL,
        });
      }
    },
    calendarChangeBadaniaSE(date, position) {
      if (position == "start") {
        this.BadaniaLekarskie[0] = date;
        this.BadaniaLekarskie[1] = date ? moment(date).add("years", 1) : null;
      } else {
        this.BadaniaLekarskie[1] = date;
      }
    },
    calendarChangeBHP(date, position) {
      if (position == "start") {
        this.SzkolenieBHP[0] = date;
        this.SzkolenieBHP[1] = date ? moment(date).add("years", 1) : null;
      } else {
        this.SzkolenieBHP[1] = date;
      }
    },
    calendarChangeEvaluation(date, index) {
      if (date.length == 2) {
        this.evaluationFormEmployeeInformation[index].date = [
          date[0]._d,
          date[1]._d,
        ];
      }
    },
    calendarChangeGoals(date, index) {
      if (date.length == 2) {
        this.employeeGoalsInformation[index].date[0] = date[0]._d;
        this.employeeGoalsInformation[index].date[1] = date[1]._d;
      }
    },
    calendarChangeСompetence(date, index) {
      if (date.length == 2) {
        this.competenceEmployeeInformation[index].date = [
          date[0]._d,
          date[1]._d,
        ];
      }
    },
    calendarChangeTraining(date, index) {
      if (date.length == 2) {
        this.trainingEmployeeInformation[index].date = [date[0]._d, date[1]._d];
      }
    },
    handleChangeYearUrlopu(value, index) {
      this.holidaysMass[index].date = value;
    },
    // handleChangeDaysInYearUrlopu(value, index) {
    //   if (value.match(/^-{0,1}\d+$/) !== null && value[0].length <= 3) {
    //     this.holidaysMass[index].name = value;
    //   } else {
    //     this.holidaysMass[index].name = value.slice(-1);
    //   }
    // },
    handleChangeFormaRozwiazania(value) {
      this.FormaRozwiazania = value;
    },
    handleChangeTypZatrudnienia(value) {
      this.TypZatrudnienia = value;
    },
    beforeUpload(file) {
      this.Zatacznik = [...this.Zatacznik, file];
      return false;
    },
    handleUploadFile() {
      var formData = new FormData();
      this.Zatacznik.forEach((file) => {
        formData.append("files[]", file);
      });
      return formData;
    },
    searchUser(value) {
      this.searchUserInput = value;
    },
    async changeCurrentUserIdForEdit(index) {
      let key = this.userInfo.findIndex((el) => el.ID == index);
      this.editableAllFields = false;
      this.editableAllFields2 = false;
      if (
        this.userInfo.length != 0 &&
        (this.isAdmin ||
          this.userAccess.length != 0 ||
          this.currentUserObj.ID == this.userInfo[key].ID)
      ) {
        this.$emit("changecurrentUserIdForEdit", key);
        this.$emit("loadSelectedClosedData", 2);
      } else {
        this.$message.warning(this.$t("Access is denied"));
      }
    },
    editAllFields() {
      this.companyTitle = this.closedUserData.NazwaFirmy
        ? this.closedUserData.company.TITLE
        : "";
      this.idFileRemove = [];
      if (this.isAdmin || this.userAccess.indexOf("HR") != -1) {
        this.editableAllFields = true;
        this.editableAllFields2 = true;
        this.formFileList();
      } else {
        if (this.userAccess.indexOf("Office") != -1) {
          this.editableAllFields = true;
        } else if (this.userAccess.indexOf("Chief") != -1) {
          let yes_no = false;
          for (
            let i = 0;
            i < this.infoo_currentUsersInDepartments.length;
            i++
          ) {
            for (
              let j = 0;
              j < this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT.length;
              j++
            ) {
              if (
                +this.infoo_currentUsersInDepartments[i] ==
                +this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT[j]
              ) {
                yes_no = true;
              }
            }
          }
          if (yes_no) {
            this.editableAllFields2 = true;
          } else {
            this.$message.warning(this.$t("Access is denied"));
          }
        }
      }
    },
    cancelAllFields() {
      this.editableAllFields = false;
      this.editableAllFields2 = false;
    },
    addNewAdditionalInfofmation() {
      this.additionalEmployeeInformation.push({
        name: "",
        status: false,
      });
    },
    deleteAdditionalInfoItem(index) {
      this.additionalEmployeeInformation.splice(index, 1);
    },
    addNewEmployeeDevelopmentInfoGoals() {
      this.employeeGoalsInformation.push({
        name: "",
        date: [],
      });
    },
    addNewEmployeeDevelopmentInfoСompetence() {
      this.competenceEmployeeInformation.push({
        name: "",
        date: [],
      });
    },
    addNewEmployeeDevelopmentInfoTraining() {
      this.trainingEmployeeInformation.push({
        name: "",
        date: [],
      });
    },
    addNewEmployeeDevelopmentInfoEvaluation() {
      this.evaluationFormEmployeeInformation.push({
        name: "",
        date: [],
      });
    },
    addholidaysMass() {
      this.holidaysMass.push({
        name: "",
        date: moment().format("YYYY"),
      });
    },
    deleteAdditionalInfoItemGoals(index) {
      this.employeeGoalsInformation.splice(index, 1);
    },
    deleteAdditionalInfoItemCompetence(index) {
      this.competenceEmployeeInformation.splice(index, 1);
    },
    deleteAdditionalInfoItemTraining(index) {
      this.trainingEmployeeInformation.splice(index, 1);
    },
    deleteAdditionalInfoItemEvaluation(index) {
      this.evaluationFormEmployeeInformation.splice(index, 1);
    },
    deleteholidaysMass(index) {
      this.holidaysMass.splice(index, 1);
    },
    async saveAllFields() {
      let url = "/php/request.php";

      if (
        this.competenceEmployeeInformation.find((el) => {
          if (el.name == "" || el.date.length != 2) {
            return el;
          }
        }) !== undefined
      ) {
        this.$message.warning(this.$t("This is a warning competence"));
        return;
      }
      if (
        this.employeeGoalsInformation.find((el) => {
          if (el.name == "" || el.date.length != 2) {
            return el;
          }
        }) !== undefined
      ) {
        this.$message.warning(this.$t("This is a warning goals"));
        return;
      }
      if (
        this.trainingEmployeeInformation.find((el) => {
          if (el.name == "" || el.date.length != 2) {
            return el;
          }
        }) !== undefined
      ) {
        this.$message.warning(this.$t("This is a warning training"));
        return;
      }
      if (
        this.evaluationFormEmployeeInformation.find((el) => {
          if (el.name == "" || el.date.length != 2) {
            return el;
          }
        }) !== undefined
      ) {
        this.$message.warning(this.$t("This is a warning evaluation"));
        return;
      }

      if (
        this.holidaysMass.find((el) => {
          if (el.name == "" || el.date == "") {
            return el;
          }
        }) !== undefined
      ) {
        this.$message.warning(this.$t("This is a warning wymiar urlopu"));
        return;
      }
      let dataClose = {
        token: updateAuth().token,
        domain: updateAuth().domain,
        run: "saveClasedData",
        user_id: this.userInfo[this.currentUserIdForEdit].ID,
        StanZatrudnienia: this.StanZatrudnienia,
        FormaRozwiazania:
          this.StanZatrudnienia == "Zwolniony" ? this.FormaRozwiazania : "",
        TypZatrudnienia: this.TypZatrudnienia,
        NazwaFirmy: this.NazwaFirmy,
        DataZatrudnienia:
          this.DataZatrudnienia && this.DataZatrudnienia != ""
            ? moment(this.DataZatrudnienia).format("YYYY-MM-DD")
            : " ",
        DataZakonczeniaRozwiazania: this.DataZakonczeniaRozwiazania
          ? moment(this.DataZakonczeniaRozwiazania).format("YYYY-MM-DD")
          : " ",
        dataZvolnienia:
          this.StanZatrudnienia == "Zwolniony" && this.dataZvolnienia
            ? moment(this.dataZvolnienia).format("YYYY-MM-DD")
            : " ",
        Wynagrodzenie: this.Wynagrodzenie,
        Prowizja: this.Prowizja,
        Premia: this.Premia,
        additionalEmployeeInformation: JSON.stringify(
          this.additionalEmployeeInformation
        ),
        BadaniaLekarskie:
          this.BadaniaLekarskie.length &&
          this.BadaniaLekarskie[0] &&
          this.BadaniaLekarskie[1]
            ? JSON.stringify([
                this.BadaniaLekarskie[0].format("YYYY-MM-DD"),
                this.BadaniaLekarskie[1].format("YYYY-MM-DD"),
              ])
            : "[]",
        SzkolenieBHP:
          this.SzkolenieBHP.length &&
          this.SzkolenieBHP[0] &&
          this.SzkolenieBHP[1]
            ? JSON.stringify([
                this.SzkolenieBHP[0].format("YYYY-MM-DD"),
                this.SzkolenieBHP[1].format("YYYY-MM-DD"),
              ])
            : "[]",
        WymiarUrlopu: JSON.stringify(this.holidaysMass),
        Ekwiwalent: this.Ekwiwalent,
        Student: this.Student,
        Samozatrudnienie: this.Samozatrudnienie,
        LiczbaDostepnychDni: this.LiczbaDostepnychDni,
        employeeGoalsInformation: JSON.stringify(this.employeeGoalsInformation),
        competenceEmployeeInformation: JSON.stringify(
          this.competenceEmployeeInformation
        ),
        trainingEmployeeInformation: JSON.stringify(
          this.trainingEmployeeInformation
        ),
        evaluationFormEmployeeInformation: JSON.stringify(
          this.evaluationFormEmployeeInformation
        ),
        PlanRozwojuPracownika: this.PlanRozwojuPracownika,
      };

      let newDataClose = {};
      for (let key in dataClose) {
        if (
          key != "token" ||
          key != "domain" ||
          key != "run" ||
          key != "user_id"
        ) {
          // if (
          //   dataClose[key] != Array.isArray(this.closedUserData[key])
          //     ? JSON.stringify(this.closedUserData[key])
          //     : this.closedUserData[key]
          // ) {

          let oldField = Array.isArray(this.closedUserData[key])
            ? JSON.stringify(this.closedUserData[key])
            : this.closedUserData[key] !== null
            ? this.closedUserData[key]
            : JSON.stringify([]);
          let newField = dataClose[key];

          if (oldField != newField) {
            if (
              !(oldField === "[]" && newField === "") ||
              !(oldField === "" && newField === "[]") ||
              !(oldField === " " && newField === "[]") ||
              !(oldField === "<empty string>" && newField === "[]") ||
              !(oldField === "[]" && newField === "<empty string>") ||
              !(oldField === "[]" && newField === " ")
            ) {
              newDataClose[key] = {};
              newDataClose[key].old = oldField;
              newDataClose[key].new = newField;
            }
          } else if (key == "WymiarUrlopu") {
            newDataClose[key] = {};
            newDataClose[key].old = oldField;
            newDataClose[key].new = newField;
          }
          // }
        } else {
          newDataClose[key] = dataClose[key];
        }
      }

      newDataClose.idFileRemove = this.idFileRemove;
      newDataClose.token = dataClose.token;
      newDataClose.domain = dataClose.domain;
      newDataClose.run = dataClose.run;
      newDataClose.user_id = dataClose.user_id;

      const response = await fetch(url, {
        method: "POST",
        body: generateFormDataWithImage(newDataClose, this.Zatacznik),
      });

      const results = await response.json();
      if (results.status == "success") {
        this.$emit("loadSelectedClosedData", 2);
      }
      this.editableAllFields = false;
      this.editableAllFields2 = false;
      this.idFileRemove = [];
    },
    initData() {
      this.StanZatrudnienia = this.closedUserData.StanZatrudnienia;
      this.FormaRozwiazania = this.closedUserData.FormaRozwiazania;
      this.TypZatrudnienia = this.closedUserData.TypZatrudnienia;
      this.NazwaFirmy =
        this.closedUserData.NazwaFirmy &&
        this.closedUserData.NazwaFirmy != "undefined"
          ? this.closedUserData.NazwaFirmy
          : "";
      this.DataZatrudnienia = this.closedUserData.DataZatrudnienia
        ? this.closedUserData.DataZatrudnienia == " "
          ? null
          : moment(this.closedUserData.DataZatrudnienia)
        : null;

      this.DataZakonczeniaRozwiazania = this.closedUserData
        .DataZakonczeniaRozwiazania
        ? this.closedUserData.DataZakonczeniaRozwiazania == " "
          ? null
          : moment(this.closedUserData.DataZakonczeniaRozwiazania)
        : null;
      this.dataZvolnienia = this.closedUserData.dataZvolnienia
        ? this.closedUserData.dataZvolnienia == " "
          ? null
          : moment(this.closedUserData.dataZvolnienia)
        : null;
      this.Wynagrodzenie = this.closedUserData.Wynagrodzenie;
      this.Prowizja = this.closedUserData.Prowizja;
      this.Premia = this.closedUserData.Premia;

      this.PlanRozwojuPracownika = this.closedUserData.PlanRozwojuPracownika;
      this.Zatacznik = [];

      this.Ekwiwalent = this.closedUserData.Ekwiwalent;
      this.Student = this.closedUserData.Student;
      this.Samozatrudnienie = this.closedUserData.Samozatrudnienie;
      this.LiczbaDostepnychDni = this.closedUserData.LiczbaDostepnychDni;

      this.additionalEmployeeInformation = Array.isArray(
        this.closedUserData.additionalEmployeeInformation
      )
        ? this.closedUserData.additionalEmployeeInformation.map((el) => {
            return {
              name: el.name,
              status: el.status,
            };
          })
        : [];

      for (let i of this.adtlEmplInfDataSource) {
        if (
          this.additionalEmployeeInformation.findIndex((x) => x.name == i) == -1
        ) {
          this.additionalEmployeeInformation.push({
            name: i,
            status: false,
          });
        }
      }

      this.BadaniaLekarskie = Array.isArray(
        this.closedUserData.BadaniaLekarskie
      )
        ? [
            this.closedUserData.BadaniaLekarskie[0]
              ? moment(this.closedUserData.BadaniaLekarskie[0])
              : null,
            this.closedUserData.BadaniaLekarskie[1]
              ? moment(this.closedUserData.BadaniaLekarskie[1])
              : null,
          ]
        : [];

      this.SzkolenieBHP = Array.isArray(this.closedUserData.SzkolenieBHP)
        ? [
            this.closedUserData.SzkolenieBHP[0]
              ? moment(this.closedUserData.SzkolenieBHP[0])
              : null,
            this.closedUserData.SzkolenieBHP[1]
              ? moment(this.closedUserData.SzkolenieBHP[1])
              : null,
          ]
        : [];

      this.holidaysMass = Array.isArray(this.closedUserData.WymiarUrlopu)
        ? this.closedUserData.WymiarUrlopu
        : [];
      this.employeeGoalsInformation = Array.isArray(
        this.closedUserData.employeeGoalsInformation
      )
        ? this.closedUserData.employeeGoalsInformation.map((el) => {
            return {
              name: el.name,
              date: [el.date[0], el.date[1]],
            };
          })
        : [];

      this.competenceEmployeeInformation = Array.isArray(
        this.closedUserData.competenceEmployeeInformation
      )
        ? this.closedUserData.competenceEmployeeInformation.map((el) => {
            return {
              name: el.name,
              date: [el.date[0], el.date[1]],
            };
          })
        : [];

      this.trainingEmployeeInformation = Array.isArray(
        this.closedUserData.trainingEmployeeInformation
      )
        ? this.closedUserData.trainingEmployeeInformation.map((el) => {
            return {
              name: el.name,
              date: [el.date[0], el.date[1]],
            };
          })
        : [];

      this.evaluationFormEmployeeInformation = Array.isArray(
        this.closedUserData.evaluationFormEmployeeInformation
      )
        ? this.closedUserData.evaluationFormEmployeeInformation.map((el) => {
            return {
              name: el.name,
              date: [el.date[0], el.date[1]],
            };
          })
        : [];
    },
  },
  mounted() {
    this.initData();
    BX24.fitWindow();
  },
};
</script>

<style scoped>
.headerListData .ant-list-item-meta {
  padding: 5px;
}

.headerListData .ant-list-item-meta-content {
  text-align: left;
  margin: auto;
}
.headerListData .ant-list-item-meta-description {
  color: white;
}

.itemsInfo {
  display: block;
  width: 40%;
  text-align: left;
  overflow: hidden;
  margin: 0;
}
.itemsInfoTitle,
.itemsInfoSubTitle {
  display: block;
  width: 30%;
  text-align: left;
  padding-left: 5px;
  margin: 0;
  border-right: 1px solid lightgray;
}

#mainClosedDataWrapper {
  font-weight: 200;
}

#chooseEmployee {
  font-weight: 200;
}

.itemsInfo {
  border-left: 1px solid lightgray;
  font-weight: 200;
}
.btn-closed,
.itemsInfoWorker {
  font-weight: 200;
}

.itemsInfoTitle,
.itemsInfoSubTitle,
.headerListData {
  font-weight: 500;
}

#employmentData .itemsInfo,
#employmentData .itemsInfoTitle {
  width: 50%;
  padding: 0 0 0 5px;
  line-height: 2;
}

#employmentData .itemsInfoUrlop {
  padding: 0;
}

#workerData .itemsInfoWorker {
  text-align: left;
  padding-left: 5px;
  width: 70%;
}

.headerListData .ant-list-item {
  border-radius: 4px 4px 0 0;
  background-color: #0083dc;
  padding-left: 5px;
}
#employmentData .ant-list-item,
#workerData .ant-list-item {
  padding: 0;
}

.ant-btn-primary,
.ant-btn-danger {
  color: #fff !important;
}

#employmentData,
#workerData {
  margin-bottom: 10px;
}
</style>
